"use client";

import ErrorPage from "apps/website/components/page/ErrorPage/ErrorPage";

export default function ErrorBoundary() {
  return (
    <ErrorPage
      title={"Looks like something went wrong..."}
      body={"Please try again later"}
      ctas={[
        {
          id: "home",
          to: "/",
          name: "Back to home page",
        },
      ]}
    />
  );
}
